import styled from 'styled-components/native';

import { horizontalScale, verticalScale } from '~/utils/layout';

export const Content = styled.View`
  justify-content: center;
  flex: 1;
`;

export const Box = styled.View`
  align-items: center;
  margin: 0 auto;
  padding: ${horizontalScale(54)}px ${verticalScale(96)}px;
  width: ${verticalScale(876)}px;
`;

export const IconContent = styled.View`
  margin-bottom: ${verticalScale(20)}px;
`;

const BaseText = styled.Text`
  color: ${({ theme }) => theme.colors.text.default};
`;

export const Title = styled(BaseText)`
  font-size: ${verticalScale(32)}px;
  margin-bottom: ${verticalScale(16)}px;
  text-align: center;
`;

export const Description = styled(BaseText)`
  font-size: ${verticalScale(24)}px;
  line-height: ${verticalScale(36)}px;
  margin: 0 auto ${verticalScale(32)}px auto;
  text-align: center;
`;

export const ProgramsList = styled.View`
  margin: 0 auto ${verticalScale(32)}px auto;
  flex-direction: column;
  min-height: ${verticalScale(50)}px;
`;

export const ProgramsItem = styled.View`
  flex-direction: row;
`;

export const ProgramsItemDevice = styled(BaseText)`
  font-size: ${verticalScale(24)}px;
  font-weight: 500;
  margin: 0 auto ${verticalScale(12)}px auto;
`;

export const Buttons = styled.View`
  flex-direction: row;
  justify-content: center;
  width: ${verticalScale(850)}px;
`;
